const PostCardSkeleton = ({ compact = false }) => {
  return (
    <div className={`w-full mx-auto min-w-0 ${compact ? 'max-w-full px-2 sm:px-0' : 'max-w-2xl'}`}>
      <div className="relative bg-white dark:bg-slate-800 rounded-3xl shadow-lg overflow-hidden border-2 border-gray-200">
        <div className="p-6 sm:p-8 animate-pulse">
          
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 rounded-full bg-gray-200" />
              <div>
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" />
                <div className="h-3 w-24 bg-gray-200 rounded" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="mb-6 space-y-3">
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="h-4 w-3/4 bg-gray-200 rounded" />
          </div>

          {/* Vote buttons */}
          <div className="flex gap-2 mb-4">
            <div className="h-10 flex-1 bg-gray-200 rounded-lg" />
            <div className="h-10 flex-1 bg-gray-200 rounded-lg" />
            <div className="h-10 flex-1 bg-gray-200 rounded-lg" />
          </div>

          {/* Actions */}
          <div className="flex justify-between">
            <div className="h-8 w-20 bg-gray-200 rounded" />
            <div className="flex gap-2">
              <div className="h-8 w-8 bg-gray-200 rounded-full" />
              <div className="h-8 w-8 bg-gray-200 rounded-full" />
              <div className="h-8 w-8 bg-gray-200 rounded-full" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PostCardSkeleton;